module.exports = __webpack_public_path__ + "static/media/verbs_in_ui0.9e5de604.JPG";